import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/index/notices/notices.vue'
wx.createPage(MiniProgramPage)